/* eslint-disable no-prototype-builtins */
/* eslint-disable no-underscore-dangle */
/* eslint-disable complexity */
import FeedApi from "./feed.js";

export default class FeedEvents {
  constructor(vueInstance) {
    this.vueInstance = vueInstance;
    this.feedApiService = new FeedApi();
  }

  _mixPanelData(post, index) {
    return {
      "post id": post.id,
      "position in feed": index,
      "post type": post.postType,
      "post created timestamp": post.createdAt,
      "post author id": post.userId,
      "post author brand name": post.brand ? post.brand.companyName : "",
      "# of tags": post.media && post.media.productTags ? post.media.productTags.length : 0,
      "brand values": post.brand ? post.brand.values : "",
      "caption character count":
        post.postContent && post.postContent.hasOwnProperty("body") ? post.postContent.body.length : 0,
      "media url": post.media && post.media.hasOwnProperty("croppedUrl") ? post.media.croppedUrl : "",
    };
  }

  wantPost(post, index) {
    this.feedApiService.makePostWanted(post.id).then(() => {
      this.vueInstance.$ma.trackEvent({
        action: "Unwant Post",
        properties: this._mixPanelData(post, index),
      });
    });
  }

  unWantPost(post, index) {
    this.feedApiService.makePostUnWanted(post.id).then(() => {
      return this.vueInstance.$ma.trackEvent({
        action: "Want Post",
        properties: this._mixPanelData(post, index),
      });
    });
  }

  viewedAPost(post, index) {
    this.feedApiService.viewedAPost(post.id).then(() => {
      return this.vueInstance.$ma.trackEvent({
        action: "View Post",
        properties: this._mixPanelData(post, index),
      });
    });
  }

  postCreate(referer) {
    return this.vueInstance.$ma.trackEvent({
      action: "Create Post",
      properties: {
        "entry point": referer,
      },
    });
  }

  messageBrand(post, index) {
    return this.vueInstance.$ma.trackEvent({
      action: "Message Brand",
      properties: this._mixPanelData(post, index),
    });
  }

  followBrand(post, index) {
    this.feedApiService.followBrand(post.id).then(() => {
      return this.vueInstance.$ma.trackEvent({
        action: "Follow Brand",
        properties: this._mixPanelData(post, index),
      });
    });
  }
  unfollowBrand(post, index) {
    this.feedApiService.unfollowBrand(post.id).then(() => {
      return this.vueInstance.$ma.trackEvent({
        action: "unFollow Brand",
        properties: this._mixPanelData(post, index),
      });
    });
  }

  originalImageUploaded(media) {
    return this.vueInstance.$ma.trackEvent({
      action: "Original Image Uploaded",
      properties: {
        "media id": media.media_id,
        "original url": media.original_url,
      },
    });
  }

  croppedImageUploaded(media) {
    return this.vueInstance.$ma.trackEvent({
      action: "Cropped Image Uploaded",
      properties: {
        "media id": media.media_id,
        "original url": media.cropped_url,
      },
    });
  }

  postPublished(draftPost, userInfo) {
    const parentCategory = draftPost.tags.map((tag) => {
      // If we have a category name, return it,
      if (tag.categories?.length && tag.categories[0]?.name) {
        return tag.categories[0].name;
      }
      // Otherwise, return an empty string.
      return "";
    });
    const tagTypes = draftPost.tags.map((tag) => tag.tag_type);

    return this.vueInstance.$ma.trackEvent({
      action: "Publish Post",
      properties: {
        "# of tags": draftPost.tags.length,
        "caption character count": draftPost.caption.length,
        "post author email": userInfo.email,
        "tag types present": [...new Set(tagTypes)].join(","),
        "product tag parent category": [...new Set(parentCategory)].join(","),
      },
    });
  }

  tagCreated(media, productData) {
    return this.vueInstance.$ma.trackEvent({
      action: "Tag Created",
      properties: {
        "tag type": productData.tag_type,
        "media id": media.media_id,
        category: productData.categories && productData.categories.length ? productData.categories[0].name : "",
      },
    });
  }

  tagViewed(postData, tagData) {
    const mixpanelProps = this._mixPanelData(postData);
    return this.vueInstance.$ma.trackEvent({
      action: "Tag Details Viewed",
      properties: {
        "tag type": tagData.tag_type,
        "product tag parent category": tagData.parent_category,
        ...mixpanelProps,
      },
    });
  }

  tagCtaClicked(postData, tagData) {
    const mixpanelProps = this._mixPanelData(postData);
    return this.vueInstance.$ma.trackEvent({
      action: "Tag CTA Clicked",
      properties: {
        "tag type": tagData.tag_type,
        "product tag parent category": tagData.parent_category,
        ...mixpanelProps,
      },
    });
  }

  tagDeleted(mediaData, tagData) {
    return this.vueInstance.$ma.trackEvent({
      action: "Tag Deleted",
      properties: {
        "tag type": tagData.tag_type,
        "product tag parent category": tagData.parent_category,
        "media id": mediaData.media_id,
        "# of tags": mediaData.total_tags,
      },
    });
  }
  promoCodeUsed(postData, userData) {
    return this.vueInstance.$ma.trackEvent({
      action: "Promo Added to Post",
      properties: {
        email: userData.email,
        brand: userData.brand_vanity_url_name,
        "code used": postData.promo_code.name,
        "code message": postData.promo_code.message,
        post_id: postData.post_id,
      },
    });
  }

  track(eventType, data, extraData) {
    switch (eventType) {
      case "LIKE":
        this.wantPost(data, extraData);
        break;
      case "VIEW":
        this.viewedAPost(data, extraData);
        break;
      case "DISLIKE":
        this.unWantPost(data, extraData);
        break;
      case "BULK":
        break;
      case "POST_CREATE_VIEW":
        this.postCreate(data);
        break;
      case "MESSAGE_BRAND":
        this.messageBrand(data, extraData);
        break;
      case "FOLLOW_BRAND":
        this.followBrand(data, extraData);
        break;
      case "UNFOLLOW_BRAND":
        this.unfollowBrand(data, extraData);
        break;
      case "ORIGINAL_IMAGE_UPLOADED":
        this.originalImageUploaded(data);
        break;
      case "CROPPED_IMAGE_UPLOADED":
        this.croppedImageUploaded(data);
        break;
      case "PUBLISH_POST":
        this.postPublished(data, extraData);
        break;
      case "TAG_CREATED":
        this.tagCreated(data, extraData);
        break;
      case "PRODUCT_TAG_VIEWED":
        this.tagViewed(data, extraData);
        break;
      case "PRODUCT_TAG_CTA_CLICKED":
        this.tagCtaClicked(data, extraData);
        break;
      case "TAG_DELETED":
        this.tagDeleted(data, extraData);
        break;
      case "PROMO ADDED TO POST":
        this.promoCodeUsed(data, extraData);
        break;
    }
  }
}
